import React, { useState, useEffect } from "react";
import "./NewOrderEntryModal.css"; // Ensure you have this CSS file

const NewOrderEntryModal = ({ customers, onSubmit, onClose }) => {
  const [entryData, setEntryData] = useState({
    party_name: "",
    sales_employee: "",
    mode_of_transport: "",
    company_name: "",
    value_of_order: "",
    category_of_order: "",
    priority_of_order: "Normal", // Default value
    payment_status: "",
    remarks: "",
    is_pharmaflow: "No", // Added for PharmaFlow checkbox
  });

  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  useEffect(() => {
    // Fetch customers and other initializations remain the same
    setFilteredCustomers(customers);
  }, [customers]);

  const salesEmployees = [
    "Aarti",
    "Aarti Sharma",
    "Ajay",
    "Akshay",
    "Anil",
    "Dolly",
    "Gobind",
    "Jyoti",
    "Lovish",
    "Manpreet",
    "Neetu",
    "Pankaj Bhatt",
    "Pankaj Rawat",
    "Prabhjot",
    "Priya",
    "Rajneesh",
    "Sanju",
    "Sarita",
    "Satyam",
    "Shreya",
    "Suman",
    "Tarun",
    "Usha",
    "Yashika",
  ];

  const modeOfTransportOptions = ["Transport", "Courier", "By Hand", "Railway"];
  const companyNames = ["Trumac", "Camrut", "Medisync", "Cialto", "Pythus"];
  const categoryOfOrderOptions = ["Big", "Small"];

  const paymentStatusOptions = [
    "Received",
    "Credit",
    "Pack & Hold",
    "DOD",
    "COD",
    "Self",
    "Advance",
    "Credit by MD",
    "Replacement",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEntryData({ ...entryData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    setEntryData({
      ...entryData,
      is_pharmaflow: e.target.checked ? "Yes" : "No",
    });
  };

  const handlePartyNameChange = (e) => {
    handleChange(e);
    const input = e.target.value.toLowerCase();
    const filtered = customers.filter(
      (customer) =>
        customer &&
        customer.customer_name &&
        customer.customer_name.toLowerCase().includes(input)
    );
    setFilteredCustomers(filtered);
    setIsDropdownVisible(input.length > 0 && filtered.length > 0); // Show dropdown if input is not empty and there are matches
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Call onSubmit prop with entryData
    try {
      await onSubmit(entryData);
      onClose(); // Close modal after successful submission
    } catch (error) {
      console.error("Failed to submit new order entry:", error);
    }
  };

  return (
    <div className="new-entry-modal">
      <div className="modal-content">
        <span className="close-button" onClick={onClose}>
          &times;
        </span>
        <h2>New Order Entry</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="party_name"
              value={entryData.party_name}
              onChange={handlePartyNameChange}
              placeholder="Party Name"
              autoComplete="off"
              required
            />
            {entryData.party_name && isDropdownVisible && (
              <ul className="customer-dropdown">
                {filteredCustomers.map((customer) => (
                  <li
                    key={customer.id}
                    onClick={() => {
                      setEntryData({
                        ...entryData,
                        party_name: customer.customer_name,
                      });
                      setIsDropdownVisible(false); // Hide dropdown after selection
                    }}
                  >
                    {customer.customer_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <select
            name="sales_employee"
            value={entryData.sales_employee}
            onChange={handleChange}
            required
          >
            <option value="">Select Sales Employee</option>
            {salesEmployees.map((employee) => (
              <option key={employee} value={employee}>
                {employee}
              </option>
            ))}
          </select>
          <select
            name="mode_of_transport"
            value={entryData.mode_of_transport}
            onChange={handleChange}
            required
          >
            <option value="">Select Mode of Transport</option>
            {modeOfTransportOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select
            name="company_name"
            value={entryData.company_name}
            onChange={handleChange}
            required
          >
            <option value="">Select Company</option>
            {companyNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
          <input
            type="number"
            name="value_of_order"
            value={entryData.value_of_order}
            onChange={handleChange}
            placeholder="Value of Order"
            onWheel={(e) => e.target.blur()}
            required
          />
          <select
            name="category_of_order"
            value={entryData.category_of_order}
            onChange={handleChange}
            required
          >
            <option value="">Select Category of Order</option>
            {categoryOfOrderOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select
            name="priority_of_order"
            value={entryData.priority_of_order}
            onChange={handleChange}
            required
          >
            <option value="Normal">Normal</option>
            <option value="Urgent">Urgent</option>
          </select>
          <select
            name="payment_status"
            value={entryData.payment_status}
            onChange={handleChange}
            required
          >
            <option value="">Select Payment Status</option>
            {paymentStatusOptions.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
          <label className="form-group">
            PharmaFlow:
            <input
              type="checkbox"
              checked={entryData.is_pharmaflow === "Yes"}
              onChange={handleCheckboxChange}
            />
          </label>
          <textarea
            name="remarks"
            value={entryData.remarks}
            onChange={handleChange}
            placeholder="Remarks"
          ></textarea>
          {/* Assume 'imageOfBuilty' will be handled differently due to file input */}
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default NewOrderEntryModal;
